<template>
    <section>
        <div class="box" >
            <article class="level">
                <div class="level-left">
                    <div class="is-light">
                        <form @submit.prevent="incluirAmostra" method="get">
                            <label><strong>Código de barras</strong></label>
                            <div class="field has-addons">
                                <div class="control">
                                    <b-input v-model="amostraCodigoDeBarras" ref="amostraCodigoDeBarras" id="amostraCodigoDeBarras"></b-input>
                                </div>
                                <div class="control">
                                    <b-button native-type="submit" :loading="loading">
                                        Incluir
                                    </b-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="level-right">
                    <b-button native-type="button" class="button is-warning" @click="incluirPendencias()" :loading="loading">Incluir pendências</b-button>
                </div>
            </article>
        </div>

        <b-table v-if="amostras.length > 0" :data="amostras"
                 :loading="loading"
                 striped
                 hoverable
                :checked-rows.sync="checkedRows"
                checkable
                :checkbox-position="checkboxPosition">

            <template slot-scope="props">
                <b-table-column field="Contador" label="">
                    <span class="tag is-pulled-right is-dark">{{ (props.index + 1) }}</span>
                </b-table-column>

                <b-table-column field="Amostra" label="Amostra">
                    {{ props.row.amostraCodigoDeBarras }}
                </b-table-column>

                <b-table-column field="Paciente" label="Paciente">
                    {{ props.row.pacienteNome }}
                </b-table-column>

                <b-table-column field="Material" label="Material">
                    {{ props.row.materialNome }}
                </b-table-column>

                <b-table-column field="Conservante" label="Conservante">
                    {{ props.row.conservanteNome }}
                </b-table-column>

                <b-table-column field="Exames" label="Exames">
                    <span v-for="(item, index) in props.row.examesApelidos" v-bind:key="index" class="tag is-default">
                        {{item}}<span> </span>
                    </span>
                </b-table-column>
            </template>
        </b-table>
        
        <div class='box' style="margin-top: 10px;">
            <div class="columns">
                <div class="column is-2">
                    <label><strong>Temperatura (C°)</strong></label>
                    <input type="number" v-model="temperatura" class="input" />
                </div>
                <div class="column is-2">
                    <label><strong>Latitude</strong></label>
                    <input type="text" v-model="latitude" class="input" readonly/>
                </div>
                <div class="column is-2">
                    <label><strong>Longitude</strong></label>
                    <input type="text" v-model="longitude" class="input" readonly/>
                </div>
            </div>
        </div>
        <nav class="notification is-light level">
            <div class="level-item">
                <p class="buttons">
                    <b-button type="is-primary" icon-left="check-circle" @click="enviarLote();" :loading="loading">
                        Enviar
                    </b-button>

                </p>
            </div>
        </nav>
    </section>    
</template>


<script>
    
    export default {
        data() {
            return {
                amostras: [],
                amostraCodigoDeBarras: "",
                temperatura: "",
                latitude: "",
                longitude: "",
                erros: [],
                checkedRows: [],
                loading: false,
                checkboxPosition: 'left'
            }
        },
        created() {
            this.$getLocation({})
                .then(coordinates => {
                    this.latitude = coordinates.lat
                    this.longitude = coordinates.lng
                });
        },
        methods:{
            incluirAmostra(){
                this.loading = true;

                this.$http.get('/api/portal/EnviarLoteIncluir?codigoDeBarras=' + this.amostraCodigoDeBarras)
                .then(res => res.data)
                .then(data => {
                    if (data != null && data.length != 0) {
                        for (const i in data) {
                            this.amostras.push(data[i]);
                            this.checkedRows.push(data[i]);
                        }
                    }
                    else {
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Amostra não encontrada. Verifique o conteúdo pesquisado e tente novamente.',
                            type: 'is-warning',
                            queue: false
                        });
                    }

                    this.$refs.amostraCodigoDeBarras.focus();
                    this.loading = false;
                })
                .catch((error) => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error,
                        type: 'is-danger',
                        queue: false
                    });
                    this.loading = false;
                }); 

                this.amostraCodigoDeBarras = "";
            },
            incluirPendencias(){
                this.loading = true;
                
                this.$http.get('/api/portal/EnviarLoteIncluirPendencias')
                .then(res => res.data)
                .then(data => {
                    if (data != null && data.length != 0) {
                        for (const i in data) {
                            this.amostras.push(data[i]);
                            this.checkedRows.push(data[i]);
                        }
                    }
                    else {
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Amostra não encontrada. Verifique o conteúdo pesquisado e tente novamente.',
                            type: 'is-warning',
                            queue: false
                        });
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error,
                        type: 'is-danger',
                        queue: false
                    });
                    this.loading = false;
                }); 

                this.amostraCodigoDeBarras = "";
            },
            enviarLote(){
                this.loading = true;

                const enviarLote = {
                    amostras: this.checkedRows, 
                    temperatura: this.temperatura, 
                    latitude: this.latitude, 
                    longitude: this.longitude
                };

                this.$http.post(`/api/portal/EnviarLote`, enviarLote )
                    .then(({ data }) => {
                        this.loading = false;
                        this.$router.back();
                    })
                    .catch((error) => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error,
                        type: 'is-danger',
                        queue: false
                    });
                        this.loading = false;
                    }); 

                this.amostras = [];
                this.checkedRows = [];
            }
        }
    }
</script>